export const phoneTypeOptions = ['Mobile', 'Home', 'Work', 'Unknown'];
